import React, { useState, useEffect } from 'react';
import '../styles/PacDebt.css';  // Import the CSS file

import styled from 'styled-components'
import { Link } from 'react-router-dom';
import logo from '../images/PDR_Logo_NOTEXT.png'
import userlogo from '../images/profile-picture.png'

const Header = () => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check if user is logged in on component mount
  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);
        setIsLoggedIn(true);
      } catch (error) {
        console.error('Error parsing user data:', error);
        localStorage.removeItem('user');
      }
    }
  }, []);

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    setIsLoggedIn(false);
    window.location.href = '/pdr-coreapp3/';
  };

  // Check if user has super admin role
  const isSuperAdmin = () => {
    return user && user.role && user.role.toLowerCase() === 'super admin';
  };

  const [open, setOpen] = useState(false);

  const toggleMenu = () => {
      setOpen(!open); // flips open state
    };
  
  if (!isSuperAdmin()) return null; // hide entirely if not super admin


  return (
    <StyledHeaderContainer>
      <div className="column1">
        <div className="column-logo">
          <Link to="/dashboard" className="logo"> <img src={logo} alt="pdrlogo" /></Link>
        </div>
        <div className="column-title"> Debt Management System </div>
      </div>
      <div className="column2">
        <div className="column-top-navigation">
          <nav>
            <ul className="top-navigation">
              <li><Link to="/dashboard">Home</Link></li>

              {isSuperAdmin() && (
              <li>
                {/* Only show User Management tab for super admin users */}
                <div className="dropdown">
                  <div className="dropdown-button" onClick={toggleMenu}>
                    Admin Management
                     <span className={`caret ${open ? 'open' : ''}`}>▼</span>
                  </div>

                  {open && (
                    <ul className="dropdown-menu">
                      <li><Link to="/user-management">Users and Logs</Link></li>
                    </ul>
                  )}
                </div>
              </li>
               )}
              {/* Only show User Management tab for super admin users */}
              {/* {isSuperAdmin() && (
                <li><Link to="/user-management">User Management</Link></li>
              )} */}
            </ul>
          </nav>
        </div>
      </div>
      <div className="column3">
        {isLoggedIn ? (
          <user className="user">
            <section>
              <img className="imgPhoto" alt='' src={userlogo} />
              <section>
                <name>{user.firstName} {user.lastName}</name>
                <actions>
                  {/* <a href="#settings">settings</a> | */}
                  <a href="#logout" onClick={(e) => { e.preventDefault(); handleLogout(); }}>logout</a>
                </actions>
              </section>
            </section>
          </user>
        ) : (
          // Show login link when not logged in
          <user className="user">
            <section>
              <img className="imgPhoto" alt='' src={userlogo} />
              <section>
                <name>Guest access</name>
                <actions>
                  <Link to="/auth">login</Link>
                </actions>
              </section>
            </section>
          </user>
        )}
      </div>
    </StyledHeaderContainer>
  );

};

export default Header;

const StyledHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 5fr 6fr 1fr;     /* Different column sizes */
  gap: 20px;                              /* Add space between columns */
  min-height: 5rem; 
  padding-right: 4.5rem;
  padding-left: 4.5rem;
  //background: linear-gradient(to bottom, darkslateblue, blue); 
  background: #f3f3f3;

  /*---Site Logo & Title ---*/
  .column-logo {
    flex: 1; 
    //padding: 20px;
    // border: 1px solid #ccc;
    margin: 10px;
    text-align: center;
    float: left;
  }

  .logo {
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: 500;
    color: #1a1a1a;

    img {
      height:3rem;
      width: auto;
      margin-right: 0.5rem;
      margin-left: 0.5rem;
    }
  }

  .column-title {
    flex: 1; 
    padding-top: 15px;
    margin: 10px;
    float: left;
    font-size: 20px;
    font-weight: bold;
    color: #545454;
    font-family: system-ui;
  }

  /*---Top Navigation---*/
  .column2 {
    display: flex;
    flex-direction: column;
    justify-content: center;  
    align-items: center;      
    height: 100%;             
  }

  .column-top-navigation {
    width: 100%;              
  }

  .top-navigation {
    list-style-type: none; 
    padding: 0;
    margin: 0;
    display: flex; 
    justify-content: right;
  }

  .top-navigation li {
    margin: 0 5px;
  }
     
  .top-navigation .ddl-admin {
    padding: 10px;
    border: 0;
    background: transparent;
    color: #545454; 
    font-size: 12px; 
    border-radius: 5px; 
    transition: background-color 0.3s ease; 
    font-weight: bold;
    display: block;
  }

  .top-navigation .dropdown {
    position: relative;
    width: 180px;
  }

  .top-navigation .dropdown-button {
    padding: 10px;
    background: #eee;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    color: #545454;
    font-size: 12px;
    font-weight: bold;
  }

  .top-navigation ul.dropdown-menu {
    list-style: none;
    margin: 0;
    padding: 0;
    border: 1px solid #ccc;
    background: white;
    width: 180px;
    position: absolute;
    top: 100%; /* dropdown appears below button */
    left: 0;
    box-shadow: 0px 4px 6px rgba(0,0,0,0.1);
    z-index: 10;
  }

  .top-navigation ul.dropdown-menu li {
    cursor: pointer;
  }

  .top-navigation ul.dropdown-menu li.disabled {
    color: #888;
    pointer-events: none;
  }

  .caret {
    margin-left: 8px;
    transition: transform 0.3s ease;
    font-size: 0.8em;
  }

  .caret.open {
    transform: rotate(180deg); /* points up when open */
  }
  
  .top-navigation a {
    text-decoration: none; 
    color: #545454; 
    font-size: 12px; 
    padding: 10px; 
    border-radius: 5px; 
    transition: background-color 0.3s ease; 
    font-weight: bold;
    display: block;
  }

  .top-navigation a:hover { 
    text-decoration: underline;
    color:  #2a5fe2; 
    cursor: pointer;
  }

    /*---User Profile---*/
  .column3 {
    display: flex;
    // flex-direction: column;
    justify-content: center;  
    align-items: center;      
    height: 100%;             
  }

  .userSection {
    color: white;
    font-size: 10px;
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center;     /* Center vertically */
    height: 100%;             /* Ensure it takes up the full height of the container */
      text-align: center;
    padding-left: 10px;
    }

  .user {
    padding: 5px;
    padding-bottom: 3px;
    flex-shrink: 0;
    // position: fixed;
    font-weight: 400;
    right: 0;
    color: rgba(0, 0, 0, 0.9);
    z-index: 1;

    > section {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      > section {
        display: flex;
        flex-direction: column;
        white-space: nowrap;
      }
    }

    .imgPhoto {
      height: 30px;
      width: 15px;
      clip-path: circle(50% at 50% 50%);
      margin-left: 10px;
      min-height: 51px;
      min-width: 48px;
      align-items: flex-end;
    }

    name {
      font-weight: 400;
      font-size: 14px;
      color: #545454;
      text-align: center;
    }

    actions {
      padding: .1em 0;
      font-size: .7em;
      display: flex;
      justify-content: flex-end;
      color: #006eb9;

      a {
        padding: 0 .5em;
        color: #006eb9;
        text-decoration: none;
        cursor: pointer;
        &:last-child {
          padding-right: 0;
        }
      }

      a:hover {
        color: #006eb9; 
        text-decoration: underline;
      }
    }
  }
`